<template>
  <div class="bk-assistant-result-markup">
    <div class="ck-content" v-html="markup" />
  </div>
</template>

<script setup>
defineProps({
  markup: { type: String, required: true }
});
</script>

<script>
export default {
  name: "AssistantResultMarkup"
};
</script>
